import { IconCopy, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import IconButton from '../../../components/Buttons/IconButton';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const FallbackUrlModal = ({ buttonComponent, productData, callback }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    const update = async () => {
        let postData = {};
        let localData = {
            "webFallbackUrl": document.getElementById("webFallbackUrl")?.value?.trim(),
            "iosFallbackUrl": document.getElementById("iosFallbackUrl")?.value?.trim(),
            "androidFallbackUrl": document.getElementById("androidFallbackUrl")?.value?.trim()
        }
        if (localData?.androidFallbackUrl) {
            postData.androidFallbackUrl = localData?.androidFallbackUrl;
        }
        if (localData?.iosFallbackUrl) {
            postData.iosFallbackUrl = localData?.iosFallbackUrl;
        }
        if (localData?.webFallbackUrl) {
            postData.webFallbackUrl = localData?.webFallbackUrl;
        }
        loadingShow();
        let resp = await postApi(postData, urlApi?.updateFallbackUrl);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            callback?.();
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Fallback URLs of your apps.</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    {
                        (!productData?.androidFallbackUrl && !productData?.iosFallbackUrl && !productData?.webFallbackUrl) &&
                        <p className='text-sm text-gray-400 text-center py-10'>No data available for this product. Add your apps to see their fallback URL here.</p>
                    }

                    {productData?.androidFallbackUrl && <div className='mb-2'>
                        <label htmlFor="androidFallbackUrl" className='text-sm font-semibold mb-1'>Android Fallback URL</label>
                        <div className="flex gap-3">
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" defaultValue={productData?.androidFallbackUrl} id='androidFallbackUrl' />
                            <IconButton icon={<IconCopy />} onClickFunction={() => onCopy(productData?.androidFallbackUrl)} />
                        </div>
                    </div>}
                    {productData?.iosFallbackUrl && <div className='mb-2'>
                        <label htmlFor="iosFallbackUrl" className='text-sm font-semibold mb-1'>IOS Fallback URL</label>
                        <div className="flex gap-3">
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" defaultValue={productData?.iosFallbackUrl} id='iosFallbackUrl' />
                            <IconButton icon={<IconCopy />} onClickFunction={() => onCopy(productData?.iosFallbackUrl)} />
                        </div>
                    </div>}
                    {productData?.webFallbackUrl && <div className='mb-2'>
                        <label htmlFor="webFallbackUrl" className='text-sm font-semibold mb-1'>Web Fallback URL</label>
                        <div className="flex gap-3">
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" defaultValue={productData?.webFallbackUrl} id='webFallbackUrl' />
                            <IconButton icon={<IconCopy />} onClickFunction={() => onCopy(productData?.webFallbackUrl)} />
                        </div>
                    </div>}
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Close</button>
                        {(productData?.androidFallbackUrl || productData?.iosFallbackUrl || productData?.webFallbackUrl) && <button className='primary-btn' onClick={() => update()}>Update</button>}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FallbackUrlModal